module.exports = __webpack_public_path__ + "static/media/clients_logo_7.652514fa.svg";